import { combineReducers } from "@reduxjs/toolkit";
import dashboardSlice from "./Slices/dashboardSlice";
import appSlice from "./Slices/appSlice";
import userSlice from './Slices/userSlice'
import bookedOrderSlice from "./Slices/bookedOrderSlice";
import shipmentSlice from "./Slices/shipmentSlice";
import sittingSlice from "./Slices/settingSlice";
import weightDisputeSlice from './Slices/weightDisputeSlice';
import walletTransationSlice from './Slices/walletTransactionSlice'
import invioceSlice from './Slices/invioceSlice'
import loginCredentialSlice from './Slices/customerLoginCredentialSlice'
import pickupAddressSlice from './Slices/pickupAddressSlice'
import appliedRatesSlice from './Slices/customerAppliedRatesSlice'
import blogSlice from './Slices/blogSlice'
import employeesLoginSlice from './Slices/employeesLoginSlice'
import escalationSlice from "./Slices/escalationSlice";
import customerDueSlice from './Slices/customerDueSlice'
import codRemittanceSlice from './Slices/codRemittanceSlice'
import rateUpsertSlice from './Slices/rateUpsertSlice'
import savePincodeSlice from './Slices/savePincodeSlice'
import customerSlice from './Slices/customerSlice'
import bannerSlice from './Slices/bannerSlice'
import creditNoteSlice from './Slices/creditNoteSlice'
import ndrSlice from './Slices/ndrSlice'
import callbackRequestSlice from './Slices/callbackRequestSlice'
import notificationSlice from './Slices/notificationSlice'
const rootReducer = combineReducers({
    user: userSlice,
    dashboard: dashboardSlice,
    app: appSlice,
    bookedOrder: bookedOrderSlice,
    shipment: shipmentSlice,
    setting: sittingSlice,
    weightDispute: weightDisputeSlice,
    walletTransactions: walletTransationSlice,
    invoice: invioceSlice,
    loginCredentials: loginCredentialSlice,
    pickupAddress: pickupAddressSlice,
    appliedRate: appliedRatesSlice,
    blog: blogSlice,
    employeesLogin: employeesLoginSlice,
    escalation: escalationSlice,
    customerDue: customerDueSlice,
    codRemittance: codRemittanceSlice,
    rateUpsert: rateUpsertSlice,
    pincode: savePincodeSlice,
    customer: customerSlice,
    banners: bannerSlice,
    creditNote: creditNoteSlice,
    ndr: ndrSlice,
    callbackRequest: callbackRequestSlice,
    notification: notificationSlice,
});

export default rootReducer;